import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelModeratedByAppInstanceUserResponseFilterSensitiveLog, } from "../models/models_0";
import { de_DescribeChannelModeratedByAppInstanceUserCommand, se_DescribeChannelModeratedByAppInstanceUserCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class DescribeChannelModeratedByAppInstanceUserCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "DescribeChannelModeratedByAppInstanceUser", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelModeratedByAppInstanceUserCommand")
    .f(void 0, DescribeChannelModeratedByAppInstanceUserResponseFilterSensitiveLog)
    .ser(se_DescribeChannelModeratedByAppInstanceUserCommand)
    .de(de_DescribeChannelModeratedByAppInstanceUserCommand)
    .build() {
}
